const CircularArrow = ({ color }: any) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.66699 1.33398V5.33398H5.66699M14.3337 14.6673V10.6673H10.3337'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6663 7.66749C14.6032 6.20849 14.0627 4.81058 13.128 3.68857C12.1933 2.56655 10.9159 1.7825 9.49235 1.45689C8.06875 1.13128 6.57761 1.28212 5.24806 1.88624C3.91851 2.49036 2.82411 3.51433 2.13301 4.80082M1.33301 8.33415C1.40931 9.7878 1.95929 11.1765 2.89896 12.2883C3.83863 13.4 5.11635 14.1736 6.53698 14.491C7.95761 14.8084 9.44308 14.652 10.7665 14.0459C12.09 13.4398 13.1787 12.4171 13.8663 11.1342'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default CircularArrow
